import AboutComponent1 from "../../components/AboutComponents/AboutComponent1/AboutComponent1";
// import ContactComponent1 from "../../components/ContactComponents/ContactComponent1";
import ContactComponent2 from "../../components/ContactComponents/ContactComponent2";
import { ImageUrl } from "../../config/helper";

const Contact = () => {
  return (
    <div>
      <AboutComponent1 image={ImageUrl("slice1.jpg")} heading="Contact" />
      {/* <ContactComponent1 /> */}
      <ContactComponent2 />
    </div>
  );
};

export default Contact;
